import { render, staticRenderFns } from "./TheSidebar_Project.vue?vue&type=template&id=2050031c"
import script from "./TheSidebar_Project.vue?vue&type=script&lang=js"
export * from "./TheSidebar_Project.vue?vue&type=script&lang=js"
import style0 from "./TheSidebar_Project.vue?vue&type=style&index=0&id=2050031c&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports